import React from 'react';
import { FaTimes } from 'react-icons/fa';

interface NewsModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  date: string;
  category: string;
  description: string;
  fullContent?: string;
}

const NewsModal: React.FC<NewsModalProps> = ({
  isOpen,
  onClose,
  title,
  date,
  category,
  description,
  fullContent,
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-dark-900/95 backdrop-blur-sm"
      onClick={onClose}
    >
      <div 
        className="glass rounded-2xl p-8 max-w-2xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-3">
              <span className="px-3 py-1 bg-quantum-500/20 text-quantum-400 rounded-full text-sm font-semibold">
                {category}
              </span>
              <span className="text-gray-500 text-sm">{date}</span>
            </div>
            <h2 className="text-3xl font-bold text-white mb-4">{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-dark-700 rounded-lg"
            aria-label="Close modal"
          >
            <FaTimes className="w-6 h-6" />
          </button>
        </div>

        <div className="prose prose-invert max-w-none">
          <p className="text-gray-300 text-lg mb-6 leading-relaxed">{description}</p>
          
          {fullContent && (
            <div className="text-gray-300 leading-relaxed space-y-4">
              {fullContent.split('\n\n').map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
          )}

          {!fullContent && (
            <div className="text-gray-300 leading-relaxed space-y-4">
              <p>
                Stay updated with the latest developments in the UK online casino industry. 
                We continuously monitor new casino launches, bonus updates, and regulatory changes 
                to keep you informed about the best opportunities available.
              </p>
              <p>
                Our team of experts reviews each new casino and bonus offer to ensure you have 
                access to accurate, up-to-date information that helps you make informed decisions 
                about where to play.
              </p>
            </div>
          )}
        </div>

        <div className="mt-8 pt-6 border-t border-dark-700">
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-quantum-500 to-quantum-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-quantum-600 hover:to-quantum-700 transition-all"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewsModal;

